module.exports = __webpack_public_path__ + "img/63.2b8fffd7.jpg";